import { render, staticRenderFns } from "./PublishingStatistics.vue?vue&type=template&id=18f5e37b"
import script from "./PublishingStatistics.vue?vue&type=script&lang=js"
export * from "./PublishingStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports